import './lexicalStyles.scss'
import { EditorThemeClasses } from 'lexical'

export const defaultLexicalTheme: EditorThemeClasses = {
  paragraph: 'lexical-paragraph-medium',
  text: {
    bold: 'lexical-text-bold',
    italic: 'lexical-text-italic',
    overflowed: 'lexical-text-overflowed',
    hashtag: 'lexical-text-hashtag',
    underline: 'lexical-text-underline',
    strikethrough: 'lexical-text-strikethrough',
    underlineStrikethrough: 'lexical-text-underlineStrikethrough',
    code: 'lexical-text-code',
  },
  list: {
    listitem: 'lexical-listitem',
    nested: {
      listitem: 'lexical-nested-listitem',
    },
    ol: 'lexical-list-ol',
    ul: 'lexical-list-ul',
  },
  quote: 'lexical-block-quote',
  link: 'lexical-link',
  table: 'lexical-table',
  tableCellHeader: 'lexical-table-cell-header',
  tableCell: 'lexical-table-cell',
}
